var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box_erea"},[_c('div',{staticClass:"list_gadget_erea"},[_c('b-table',{attrs:{"bordered":"","outlined":"","striped":"","hover":"","items":_vm.items,"fields":_vm.fields}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }